import React from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from 'web-library';
import { Dialog } from '@mui/material';

interface OptionalSingpassLoginModalProps {
  isOpen: boolean;
  onNotHavingSingpass: () => void;
  onHavingSingpass: () => void;
  error: string | null;
}

const OptionalSingpassLoginModal = ({
  isOpen,
  onNotHavingSingpass,
  onHavingSingpass,
  error,
}: OptionalSingpassLoginModalProps) => (
  <Dialog open={isOpen} maxWidth="sm">
    <DialogTitle>Do you have Singpass?</DialogTitle>

    <DialogContent>
      <DialogContentText>
        Please use your Singpass for account creation. If you do not have Singpass, you may proceed
        with the account creation.
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button color="secondary" onClick={onNotHavingSingpass} variant="text">
        I Do Not Have Singpass
      </Button>
      <Button variant="contained" color="secondary" type="button" onClick={onHavingSingpass}>
        I Have Singpass
      </Button>
    </DialogActions>
    <Typography align="center" color="error" variant="body2">
      {error}
    </Typography>
  </Dialog>
);

export default OptionalSingpassLoginModal;
